import { render, staticRenderFns } from "./paid_20_03_2026.vue?vue&type=template&id=42fc4227"
import script from "./paid_20_03_2026.vue?vue&type=script&lang=js"
export * from "./paid_20_03_2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports